import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';
import { ml } from '@/utils/translate_lngs';

export default (function (params) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_SHIFT_CAPACITY_NEW',
    manual: true,
  });

  useEffect(() => {
    // if (params.device_ids !== '' && params.start_time !== '' && params.end_time !== '') {
    if (
      params.start_time &&
      params.start_time !== '' &&
      params.end_time &&
      params.end_time !== ''
    ) {
      let url = `/api/produce/piece/data`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) url += '?';
        else url += '&';
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  useEffect(() => {
    if (data) {
      if (data.columns && data.columns.length > 0)
        data.columns.forEach(c => {
          if (c.class_aid === 'No shift') {
            c.class_name = ml('NO_SHIFT');
          }
        });
      if (data.data && data.data.length > 0)
        data.data.forEach(d => {
          if (d.class_aid === 'No shift') {
            d.class_name = ml('NO_SHIFT');
          }
        });
    }
  });

  return data || [];
});
